import { Permission } from './lib/permission';
import { RBAC } from './lib/rbac';
import { Role } from './lib/role';

export * from './lib/permission';
export * from './lib/rbac';
export * from './lib/role';

const rbac = new RBAC<Role, Permission>({
  role: Role.ROOT,
  permissions: [],
  children: [
    {
      // Player is a separate branch under ROOT, deliberately NOT nested under any coach role, so
      // player users can never inherit coach permissions. Permissions for the player experience can
      // be added here later as player-specific features are introduced.
      role: Role.PLAYER,
      permissions: [],
      children: [],
    },
    {
      role: Role.GUEST,
      permissions: [],
      children: [
        {
          role: Role.CUSTOMER,
          permissions: [
            // Video integrations
            Permission.INTEGRATION_READ,
            Permission.INTEGRATION_EDIT,
            // Labpano integrations
            Permission.LABPANO_INTEGRATION_AUTHENTICATE,
            // Sync integrations
            Permission.SYNERGY_INTEGRATION_UPDATE_TOKEN,
            // Tenant
            Permission.TENANT_INVITE,
            Permission.TENANT_READ_USERS,
            // Upload integrations
            Permission.FILE_UPLOAD_INTEGRATION_UPLOAD_VIDEO,
            Permission.URL_UPLOAD_INTEGRATION_UPLOAD_VIDEO,

            // Processings
            Permission.PROCESSING_START_STATISTICS,

            // Roster
            Permission.ROSTER_CREATE,
            Permission.ROSTER_CREATE_GROUPS,
            Permission.ROSTER_DELETE,
            Permission.ROSTER_EDIT,

            // Session
            Permission.SESSION_DELETE,
            Permission.SESSION_EDIT,
          ],
          children: [
            {
              role: Role.INTERNAL,
              permissions: [
                // Account
                Permission.ACCOUNT_SWITCH_TENANT,

                // Team
                Permission.TEAM_EDIT,
                // Tenant
                Permission.TENANT_READ_ALL_USERS,
              ],
              children: [
                {
                  role: Role.SUPPORT,
                  permissions: [
                    // Account
                    Permission.ACCOUNT_READ_TENANT_ID,

                    // Reports
                    Permission.REPORT_EXPORT_PDF,
                    // Sessions
                    Permission.SESSION_READ_RESOURCES,
                    Permission.SESSION_READ_PROCESSINGS,
                    // Tenant
                    Permission.TENANT_UPDATE_ATTRIBUTES,
                    Permission.TENANT_UPDATE_USER,
                    // Video integrations
                    Permission.INTEGRATION_ACTIVATE,
                    Permission.INTEGRATION_ADD_ONE,
                    Permission.INTEGRATION_DELETE,
                    Permission.INTEGRATION_EDIT,
                    Permission.INTEGRATION_EDIT_SYNC_CURSOR,
                    Permission.INTEGRATION_READ_CAMERA_IDS,
                    Permission.INTEGRATION_READ_ERROR,
                    // PlaySight integrations
                    Permission.PLAYSIGHT_INTEGRATION_CAMERA_SELECTION,
                    Permission.PLAYSIGHT_INTEGRATION_READ_CAMERA_PREVIEW,
                    // Synergy integrations
                    Permission.SYNERGY_INTEGRATION_CAMERA_SELECTION,
                  ],
                  children: [],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

export default rbac;
